import(/* webpackMode: "eager" */ "/app/components/ContactCards/ProjectContactCard.jsx");
import(/* webpackMode: "eager" */ "/app/components/Footers/FooterDefault.js");
import(/* webpackMode: "eager" */ "/app/components/Forms/ProjectForm.jsx");
import(/* webpackMode: "eager" */ "/app/components/HtmlComponent.jsx");
import(/* webpackMode: "eager" */ "/app/components/LinkComponent.js");
import(/* webpackMode: "eager" */ "/app/components/Location.jsx");
import(/* webpackMode: "eager" */ "/app/components/Nav.jsx");
import(/* webpackMode: "eager" */ "/app/components/ProjectProperties.jsx");
import(/* webpackMode: "eager" */ "/app/components/PropertyGalleryBlock.jsx");
import(/* webpackMode: "eager" */ "/app/components/ShareButton.js");
import(/* webpackMode: "eager" */ "/app/components/VideoComponent.js");
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-no-ssr.js")